import { useTheme } from "next-themes";
import { Sun, Moon, Monitor } from "@phosphor-icons/react";
import {
    DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { Button } from "../ui/button";
import { useEffect, useState } from "react";

export default function ThemeToggle({ compact }) {
    const { theme, setTheme } = useTheme();
    const [mounted, setMounted] = useState(false);
    useEffect(() => setMounted(true), []);
    if (!mounted) return null;

    const Icon = theme === "dark" ? Moon : theme === "light" ? Sun : Monitor;

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button
                    variant="ghost"
                    size="sm"
                    data-testid="theme-toggle"
                    aria-label="Toggle theme"
                    className="px-2"
                >
                    <Icon size={18} weight="duotone" />
                    {!compact && <span className="ml-2 text-sm">Theme</span>}
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" data-testid="theme-menu">
                <DropdownMenuItem onClick={() => setTheme("light")} data-testid="theme-light">
                    <Sun size={16} weight="duotone" className="mr-2" /> Light
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => setTheme("dark")} data-testid="theme-dark">
                    <Moon size={16} weight="duotone" className="mr-2" /> Dark
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => setTheme("system")} data-testid="theme-system">
                    <Monitor size={16} weight="duotone" className="mr-2" /> System
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
